export default __webpack_public_path__ + "static/media/EURt.7351fdf4.png";